<template>
    <div component="InputTel" :class="[{ invalid: !getIsValid }, { dirty: isDirty }]">
        <vue-tel-input
            ref="vueTelInput"
            v-model="currentValue"
            @onInput="onInput"
            @onValidate="onValidate"
            :onlyCountries="['sk', 'cz', 'hu', 'pl', 'at', 'de', 'es', 'fr', 'it', 'gb']"
            :defaultCountry="'SK'"
            :disabledFetchingCountry="true"
            :selectedCountryCode="true"
            :inputOptions="{ showDialCode: true }"
            :required="required"
        ></vue-tel-input>
    </div>
</template>
<script>
import VueTelInput from 'vue-tel-input';
import { formatNumber } from 'libphonenumber-js';

export default {
    name: 'InputTel',

    components: {
        VueTelInput,
    },

    props: {
        value: {
            required: true,
        },
        required: {
            default: false,
        },
    },

    data() {
        return {
            response: {
                number: '',
                isValid: false,
                country: {
                    areaCodes: null,
                    dialCode: '421',
                    iso2: 'SK',
                    name: 'Slovakia (Slovensko)',
                    priority: 0,
                },
            },
            isDirty: false,
        };
    },

    mounted() {
        // Bolo to treba natvrdo prednastavit, asi bug
        if (this.value.length) {
            this.$refs.vueTelInput.phone = this.value;
        }
    },

    methods: {
        onInput(response) {
            this.response = response;
            this.isDirty = true;
            this.$nextTick(() => {
                this.$emit('onInput', this.getResponse());
                this.$emit('input', this.getValue);
            });
        },

        onValidate(response) {
            this.response = response;
            this.$nextTick(() => this.$emit('onValidate', this.getResponse()));
        },

        getResponse() {
            return {
                ...this.response,
                number: this.getValue,
                isValid: this.getIsValid,
                isDirty: this.isDirty,
            };
        },
    },

    computed: {
        getValue() {
            return this.response.number === `+${this.response.country.dialCode}` && !this.required
                ? ''
                : this.response.number;
        },

        getIsValid() {
            const { number, country, isValid } = this.response;
            return !number.length || number === `+${country.dialCode}` ? !this.required : isValid;
        },

        currentValue: {
            get() {
                return formatNumber(this.value, this.response.country.iso2, 'International');
            },

            set(newVal) {
                // Nastavuje sa cez emit vyssie
            },
        },
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';
@import '~vue-tel-input/dist/vue-tel-input.css';

[component='InputTel'] {
    height: 25px;
    display: flex;
    position: relative;

    .vue-tel-input {
        border: 0;
        width: 100%;
        border-radius: 0;
        border-bottom: 1px solid #c4c5c6;

        &:focus,
        &:focus-within {
            outline: none;
            box-shadow: none;
        }
    }

    &.dirty {
        .vue-tel-input {
            &:focus,
            &:focus-within {
                border-color: #6ae517;
            }
        }

        &.invalid {
            .vue-tel-input {
                border-color: @accent;
            }
        }
    }
}
</style>
